import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    accountUser: graphql(`
        fragment hasPortfolio_AccountUser on AccountUserType {
            accounts {
                number
            }
        }
    `),
}

export function hasPortfolio(fragment: FragmentOf<typeof graphQLFragments.accountUser>) {
    const { accounts } = readFragment(graphQLFragments.accountUser, fragment)

    return Boolean(accounts && accounts.length > 1)
}

hasPortfolio.fragments = graphQLFragments
